import { Auth } from 'aws-amplify';
import {getFromStorage} from "../services/LocalStorage";
import {isAdminView} from "./Util";

const checkToken = () => {
    return new Promise((resolve, reject) => {
      const adminToken = getFromStorage('adminAuthToken');
      if (isAdminView() && adminToken) {
        return resolve("Bearer " + adminToken);
      }
      Auth.currentSession()
        .then((session) => {
          const idTokenExpire = session.getIdToken().getExpiration();
          const refreshToken = session.getRefreshToken();
          const currentTimeSeconds = Math.round(+new Date() / 1000);
          if (idTokenExpire < currentTimeSeconds) {
            Auth.currentAuthenticatedUser()
              .then((res) => {
                res.refreshSession(refreshToken, (err, data) => {
                  if (err) {
                    Auth.signOut()
                  } else {
                    resolve("Bearer " + data.getIdToken().getJwtToken());
                  }
                });
              }).catch((err) => {
              })
          } else {
            resolve("Bearer " + session.getIdToken().getJwtToken());
          }
        })
        .catch(() => {
          // No logged-in user: don't set auth header
          reject(null);
        });
    })
}

export default checkToken;